class ProductCount extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['count', 'dynamic', 'increase', 'decrease', 'max']
  }

  static get requiredExternalElements () {
    return ['pagination', 'product']
  }

  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()

    this.initialCount = parseInt(this.externalEls.pagination.element.dataset.paginatePage -1) * parseInt(this.externalEls.pagination.element.dataset.paginatePerPage)
    this.initialDisplay= this.initialCount

    this.max = parseInt(this.externalEls.pagination.element.dataset.paginateCount)
    this.count = (parseInt(this.externalEls.pagination.element.dataset.paginatePage) -1) * parseInt(this.externalEls.pagination.element.dataset.paginatePerPage)
    this.currentCountDisplay = this.count
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('scroll', () => {
      this.countScrolledItems()
    })
  }

  countScrolledItems() {
    const productCards = this.externalEls.product.elements

    if (window.scrollY < 5) {
      this.count = this.initialCount
      this.currentCountDisplay = this.count
      this.els.count.element.innerText = this.count
      this.els.dynamic.element.setAttribute('aria-hidden', 'true')
      productCards.forEach(productCard => {
        productCard.dataset.counted = 'false'
      })

      return
    }

    if (this.els.dynamic.element.getAttribute('aria-hidden') === 'true' && this.count > 3 || this.els.max.element.innerText !== this.max) {
      this.max = parseInt(this.externalEls.pagination.element.dataset.paginateCount)


      if (this.count > 0 && this.currentCountDisplay > 0){
        this.els.dynamic.element.setAttribute('aria-hidden', 'false')
      }
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const el = entry.target

        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          if (el.dataset.counted == 'false' || !el.dataset.counted) {
            el.dataset.counted = 'true'
            this.count++
            this.countDirection = 'down'
          }
        }
      })
    }, {
      root: null,
      threshold: 0,
    })

    const countDownObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const el = entry.target

        const fullyBelowViewport = entry.boundingClientRect.bottom >= window.innerHeight

        if (fullyBelowViewport) {
          if (el.dataset.counted === 'true') {
            el.dataset.counted = 'false'
            this.count--
            this.countDirection = 'up'
          }
        }
      })
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -20px 0px'
    })

    productCards.forEach(productCard => observer.observe(productCard))
    productCards.forEach(productCard => countDownObserver.observe(productCard))

    if (this.count % 4 === 0 || this.count == this.max) {
      if (this.countDirection === 'down') {
        this.els.increase.element.innerText = this.count
      } else {
        this.els.decrease.element.innerText = this.count
      }
    } else {
      return
    }

    if (this.countDirection === 'down' && this.count > this.currentCountDisplay || this.countDirection === 'up' && this.count < this.currentCountDisplay) {

      const countElements = [this.els.count.element, this.els.increase.element, this.els.decrease.element]

      if (this.count > 0 && this.currentCountDisplay > 0) {
        countElements.forEach(count => {
          count.style.transform = `translateY(${this.countDirection === 'down' ? '-200%' : '0%'})`

          count.addEventListener('transitionend', () => {
            count.innerText = this.count
            count.style.transition = 'none'
            count.style.transform = 'translateY(-100%)'

            void count.offsetWidth
            count.style.transition = 'transform 0.3s ease'
          }, { once: true })
        })
      } else {
        countElements.forEach(count => {
          count.innerText = this.count
        })
      }

      this.currentCountDisplay = this.count
    }
  }
}

if (!customElements.get('product-count')) {
  customElements.define('product-count', ProductCount)
}
